export default __webpack_public_path__ + "static/media/Calendar-26.00bbb906.svg";